// extracted by css-extract-rspack-plugin
module.exports =  {"template-23":"Template23-bfsx__template-23","audio-player--padded":"Template23-QIRJ__audio-player--padded"};